import { CLOUDFLARE_CUSTOMER_URL } from '@/constants/general'

import { processThumbSrc, processThumbSrcset } from './pg-thumbs-helpers'

const init = () => {
    if (typeof window === 'undefined') {
        return
    }

    const videoUrls = new Set<string>()

    function preloadVideoById(videoId: string) {
        const href = `${CLOUDFLARE_CUSTOMER_URL}${videoId}/manifest/video.mpd`

        if (videoUrls.has(href)) {
            return
        }

        videoUrls.add(href)

        const preloadLink = document.createElement('link')
        preloadLink.rel = 'preload'
        preloadLink.as = 'fetch'
        preloadLink.href = href
        preloadLink.fetchPriority = 'low'
        preloadLink.crossOrigin = 'anonymous'

        const timeout = window.setTimeout(cleanup, 15000)

        function cleanup() {
            window.clearTimeout(timeout)
            preloadLink.remove()
        }

        preloadLink.addEventListener('load', cleanup, { once: true })
        preloadLink.addEventListener('error', cleanup, { once: true })

        document.head.appendChild(preloadLink)
    }

    document.addEventListener('lazybeforeunveil', (e: Event) => {
        const target = e.target as HTMLElement & { _lazysizesWidth: number }

        if (target.dataset.videoId) {
            preloadVideoById(target.dataset.videoId)
            return
        }

        const width = target._lazysizesWidth
        if (!width) {
            return
        }
        const { src } = target.dataset
        if (!src) {
            return
        }

        target.dataset.src = processThumbSrc(src, width)
        target.dataset.srcset = processThumbSrcset(src, width)
    })
}

init()
